'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Title } from '@/ui/components'
import { memo } from 'react'
import Status from './Status'

interface Props {
  title: string
  status: 'OPEN' | 'CLOSED'
  pretitle?: string
  items: {
    label: string
    open: string | number
    total: string | number
    append?: string
  }[]
}

const ReportsAccordionHead = ({ items, title, status, pretitle }: Props) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div className={'-mr-2xl w-full'}>
      {pretitle && <div className={''}>{pretitle}</div>}
      <Title as="h3" className={'h3 pr-lg'}>
        {title}
      </Title>
      <div
        className={cn(
          'mt-xs gap-sm md:gap-2xs textstyle-sm-regular flex justify-between text-neutral-400',
          items.length > 1 ? 'max-md:flex-col' : ''
        )}
      >
        {items.map((item, index) => (
          <div
            className={'md:gap-2xs flex flex-col text-left'}
            key={`${item.label}-${index.toString()}`}
          >
            <div>{item.label}</div>
            <div>
              <span
                className={cn(
                  'textstyle-lg-bold',
                  status === 'CLOSED'
                    ? 'text-feedback-red'
                    : 'text-feedback-green'
                )}
              >
                {item.open}
              </span>{' '}
              {D['fe.reports.from']}{' '}
              <span
                className={cn(
                  'textstyle-lg-bold',
                  status === 'CLOSED'
                    ? 'text-feedback-red'
                    : 'text-feedback-green'
                )}
              >
                {item.total}
              </span>{' '}
              {item.append ? item.append : D['fe.reports.open']}
            </div>
          </div>
        ))}

        <Status status={status} />
      </div>
    </div>
  )
}

export default memo(ReportsAccordionHead)
